import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import ListViewType from '@components/ListViewType';

import Chip from '@features/filter/Chip';
import Search from '@features/filter/Common/Search';
import Sort from '@features/filter/Common/Sort';

import { clearGlobalFilter } from '@store/actions/FilterAction';

const AssetsTopFilter = ({
	onSetViewSetting,
	selectedViewType,
	toggleFilter,
	activeTab,
	totalElements,
	setShowAddModal
}) => {
	const dispatch = useDispatch();
	const totalItems = totalElements ?? 0;

	const handleShowAddModal = () => {
		setShowAddModal(true);
	};

	const getPlaceholderText = (activeTab, selectedViewType) => {
		let placeholder = '';
		if (activeTab === 'BLOCK_LIBRARY' && selectedViewType === 'CARD_VIEW') {
			placeholder = 'Block title & number';
		} else if (activeTab === 'BLOCK_LIBRARY' && selectedViewType === 'COLLECTION_VIEW') {
			placeholder = 'Collection Name';
		} else {
			placeholder = 'Reference number';
		}
		return placeholder;
	};

	useEffect(() => {
		dispatch(clearGlobalFilter());
	}, [selectedViewType, activeTab, dispatch]);
	return (
		<div className="filter-container-top block-library-filter-top d-block pt-2 pb-2">
			<div className="d-flex align-items-center justify-content-between">
				<div className="filters">
					<div className="filter-toggle" onClick={toggleFilter}>
						<img src={`${process.env.PUBLIC_URL}/icons/filter24.svg`} alt="filter" />
						<span>Filter</span>
					</div>
					<span className="items-count semibold-14 gray_dark_02 mr-2">
						{totalItems > 1 ? `${totalItems} Items` : `${totalItems} Item`}
					</span>
				</div>
				<div className="filter-actions sample-dashboard-filter">
					<Search
						placeholder={getPlaceholderText(activeTab, selectedViewType)}
						identifier={`${selectedViewType === 'CARD_VIEW' ? 'search' : 'name'}`}
					/>

					{activeTab === 'BLOCK_LIBRARY' && (
						<ListViewType
							type="BLOCK_LIBRARY_LIST"
							onSelectType={(selected) => onSetViewSetting(selected)}
						/>
					)}

					<div className="single-filter ml-3">
						<div className="transparent-sort">
							<Sort title={'ASSETS_LIST'} removedLastModified={true} />
						</div>
					</div>
					{(activeTab === 'SKETCH' || activeTab === 'ARTWORK') && (
						<button
							className="button text size32 px-0 d-flex align-items-center"
							onClick={handleShowAddModal}
						>
							<img src={`${process.env.PUBLIC_URL}/icons/add-round.svg`} alt="add" />
							<span className="ml-1">{activeTab === 'SKETCH' ? 'Sketch' : 'Artwork'}</span>
						</button>
					)}
				</div>
			</div>
			<Chip />
		</div>
	);
};

export default AssetsTopFilter;
